export const MFA_UNAVAILABLE =
  "This account needs an extra verification step that isn’t available here yet. Contact Anomalos support.";

export const PROTECT_RETRY = "Something went wrong. Try again.";

const COPY: Record<string, string> = {
  form_code_expired:
    "That code is incorrect or has expired. Try again or resend it.",
  form_code_incorrect:
    "That code is incorrect or has expired. Try again or resend it.",
  form_email_address_blocked:
    "This email isn’t eligible to create an account right now.",
  form_identifier_exists: "An account with this email already exists.",
  form_identifier_not_found: "We couldn’t find an account with that email.",
  form_password_incorrect:
    "That password doesn’t match this account. Try again or reset it.",
  form_password_length_too_short: "Use at least 8 characters.",
  form_password_pwned:
    "This password has appeared in a data breach. Choose a different one.",
  not_allowed_access:
    "This email isn’t eligible to create an account right now.",
  not_allowed_to_sign_up:
    "This email isn’t eligible to create an account right now.",
};

export interface ClerkFailure {
  code: string;
  longMessage?: string;
  message: string;
}

export const clerkFailureMessage = (
  failure: ClerkFailure | null | undefined,
  fallback = "Something went wrong. Try again."
): string | null => {
  if (!failure) {
    return null;
  }
  return (
    COPY[failure.code] ?? failure.longMessage ?? failure.message ?? fallback
  );
};
